/* eslint-disable react-hooks/exhaustive-deps */
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ContentShell from "components/ContentShell";
import Table from "components/Table";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { opacity2hex, sortArray } from "utils/miscUtils";
import configData from "config/config.json";
import { useSnackbar } from "hooks/useSnackbar";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import sessionHelper from "services/sessionHelper";
import { PermittedRoles } from "utils/permissions";
import CustomButton from "components/CustomButton";
import useConsent from "hooks/useConsent";
import { getDailyRewards } from "services/dailyRewardService";
import { getDailyRewardsColumns } from "utils/tableHelper/dailyRewardsTableHelper";

const useStyles = makeStyles((theme) => ({
  editButton: {
    backgroundColor: theme.palette.common.offWhite + opacity2hex("0.80"),
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.common.offWhite,
    },
  },
  container: {
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
}));

const RowActions = ({ data, actionHandlers: { handleDelete = () => {} } }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRowAction = (data: any) => {
    setAnchorEl(null);
    navigate(configData.routes.dailyRewards.edit?.replace(":id", data?._id));
  };

  // const hasDeletePermission = sessionHelper.hasRole(
  //   PermittedRoles.DAILYREWARDS.DELETE_ROLES
  // );

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleRowAction(data)}>Edit</MenuItem>
        {/* {hasDeletePermission && (
          <MenuItem onClick={() => handleDelete(data)}>Delete</MenuItem>
        )} */}
      </Menu>
    </>
  );
};

const DailyRewards = () => {
  const styles = useStyles();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [listData, setListData] = useState([]);
  const [orderDirection, setOrderDirection] = useState("asc");
  const { updateDetails, openConsent } = useConsent();

  const hasEditPermission = sessionHelper.hasRole(
    PermittedRoles.DAILYREWARDS.UPDATE_ROLES
  );

  const _openConsentDialog = (data: any) => {
    openConsent();
    updateDetails({ itemName: data?._id, id: data?._id });
  };

  const createBanner = () => navigate(configData.routes.dailyRewards.create);

  const fetchData = async () => {
    setLoading(true);
    try {
      const resp = await getDailyRewards();
      setListData(resp?.data.sort((a, b) => a.day - b.day));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showSnackbar(error.message, "error");
    }
  };

  const onColumnClick = (column: any) => {
    let _list = sortArray([...listData], orderDirection, column);
    setListData(_list);
    setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
  };

  useEffect(() => {
    const cols = getDailyRewardsColumns().filter(
      (col) => col.id !== "actions" || hasEditPermission
    );
    setColumns(cols);
    fetchData();
  }, [hasEditPermission]);

  return (
    <ContentShell
      title="Daily Rewards"
      loading={loading}
      actions={
        sessionHelper.hasRole(PermittedRoles.DAILYREWARDS.CREATE_ROLES) && (
          <CustomButton onClick={createBanner}>Create</CustomButton>
        )
      }
    >
      <Box className={styles.container}>
        <Table
          columns={columns}
          data={listData}
          highlightAltRow={true}
          actions={RowActions}
          onColumnClick={onColumnClick}
          actionHandlers={{
            handleDelete: _openConsentDialog,
          }}
        />
      </Box>
    </ContentShell>
  );
};

export default DailyRewards;
